export enum AssumptionRowValueType {
    DOLLAR,
    PERCENTAGE,
    NUMBER
}